import { Box, Typography } from "@mui/material";
import { HexColorPicker } from "react-colorful";
import { TextInput } from ".";

const ColorInput = ({ color, setColor, changeName, name }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography>انتخاب رنگ:</Typography>
      <TextInput label="نام رنگ" change={changeName} currentValue={name} />
      <HexColorPicker color={color} onChange={setColor} />
      <TextInput change={setColor} currentValue={color} label="کد رنگ" />
    </Box>
  );
};

export default ColorInput;
